import { render } from "./LoginComp.vue?vue&type=template&id=539b46f4"
import script from "./LoginComp.vue?vue&type=script&lang=js"
export * from "./LoginComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__